import { render, staticRenderFns } from "./NotificationsChat.vue?vue&type=template&id=75626c95&"
import script from "./NotificationsChat.vue?vue&type=script&lang=js&"
export * from "./NotificationsChat.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsChat.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports